import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnChanges, PLATFORM_ID, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, platformBrowser, SafeResourceUrl } from '@angular/platform-browser';
import { DataTaskService } from '@app/core/services/data-task.service';

@Component({
    selector: 'tt-video-tutorial',
    templateUrl: './video-tutorial.component.html',
    styleUrls: ['./video-tutorial.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class VideoTutorialComponent {
    // src = 'https://player.vimeo.com/video/1083503632?h=e2134968e9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';
    @Input()
    vtKeyno = '';

    @Input()
    videoId = 'https://www.youtube.com/embed/0RDi6YDLDKU';

    playerVars: YT.PlayerVars = {
        modestbranding: 1, // minimal YouTube logo
        rel: 0, // show only same-channel related videos
        controls: 1, // show basic controls (play, pause, progress)
        disablekb: 0, // allow keyboard shortcuts
        fs: 1, // hide fullscreen button (optional)
        iv_load_policy: 3, // hide annotations & popups
        playsinline: 1, // play inline on mobile (no forced fullscreen)
        autoplay: 0, // don’t autoplay (or 1 if you want)
        enablejsapi: 1, // allow JS control via API
        origin: window.location.origin, // recommended for security
    };

    isBrowser = false;
    constructor(private datatask: DataTaskService, private santizer: DomSanitizer, @Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
        console.log(this.isBrowser);
    }

    onStateChanged(event: YT.OnStateChangeEvent) {
        if (event.data === YT.PlayerState.PLAYING) {
            this.datatask.Post(3815, { vt_keyno: this.vtKeyno });
        }
    }
}
